module.exports = __webpack_public_path__ + "img/5ede936757cd4fbdb6247bad22bf454d.f65e829d.png";